module.exports = __webpack_public_path__ + "img/acasia-bottom.f39b3ff5.png";